<template>
  <div
    class="app"
    style="min-height: 100vh; background: #12102e; background-size: cover; background-attachment: fixed;"
  >
    <router-view></router-view>
  </div>
</template>

<script>
// import { loadTawk } from '@/utils/tawk'

export default {
  watch: {
    '$route.path'(newPath) {
      setTimeout(() => {
        const iframe = document.querySelector("iframe[title='chat widget']");
        if (iframe) {
          if (newPath === '/profile') {
            iframe.style.bottom = '1rem'; // move up to avoid profile icon
          } else {
            iframe.style.bottom = '1rem'; // default
          }
        }
      }, 1000);
    }
  },
  //   mounted() {
  //     // Also apply once when the app loads
  //     this.$watch('$route.path', this.$options.watch['$route.path'].bind(this), {
  //       immediate: true
  //     });
  //     if (window.Tawk_API && window.Tawk_API.setAttributes) {
  //         window.Tawk_API.setAttributes({
  //         name: this.$store.state.authUser.name,         // <-- Replace with your dynamic name
  //         // email: 'john@example.com' // <-- Optional
  //         }, function (error) {
  //         if (error) {
  //             console.error('Tawk.to setAttributes error:', error);
  //         }
  //         });
  //     } else {
  //         // Wait until Tawk.to is loaded
  //         const interval = setInterval(() => {
  //         if (window.Tawk_API && window.Tawk_API.setAttributes) {
  //             window.Tawk_API.setAttributes({
  //             name: 'John Doe', // <-- Replace dynamically if needed
  //             });
  //             clearInterval(interval);
  //         }
  //         }, 500);
  //     }
  //   },
  mounted() {
    // const token = localStorage.getItem('token');
    // const user = JSON.parse(localStorage.getItem('userData'));
    // if (token) {
    //     loadTawk(user);
    // }
  }
}
</script>
